'use strict';

module.exports = require('./lib/ReactDOM');



//////////////////
// WEBPACK FOOTER
// ../~/react-dom/index.js
// module id = 190
// module chunks = 47